/**
 * @generated SignedSource<<95f727d8b929d33aac8591ed5daca135>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTaskSetInput = {
  id: string;
  globalProjectId: string;
  fromSequence?: number | null;
  setName?: string | null;
  instanceName?: string | null;
  description?: string | null;
  estimateForecast?: number | null;
  clearEstimateForecast?: boolean | null;
  globalRoleId?: string | null;
  clearRole?: boolean | null;
  globalPhaseId?: string | null;
  clearPhase?: boolean | null;
  globalStatusColumnId?: string | null;
  billable?: boolean | null;
  globalLabelIds?: ReadonlyArray<string | null> | null;
  globalAssignedPersonIds?: ReadonlyArray<string | null> | null;
  boundEndDate?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTaskSetMutation$variables = {
  input: UpdateTaskSetInput;
};
export type updateTaskSetMutation$data = {
  readonly updateTaskSet: {
    readonly taskSet: {
      readonly id: string;
      readonly name: string | null;
      readonly instanceName: string | null;
      readonly description: string | null;
      readonly estimateForecast: number | null;
      readonly billable: boolean | null;
      readonly instanceCount: number | null;
      readonly role: {
        readonly id: string;
      } | null;
      readonly phase: {
        readonly id: string;
      } | null;
      readonly statusColumn: {
        readonly id: string;
      } | null;
    } | null;
    readonly instancesUpdated: number | null;
    readonly project: {
      readonly id: string;
    } | null;
  } | null;
};
export type updateTaskSetMutation = {
  variables: updateTaskSetMutation$variables;
  response: updateTaskSetMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTaskSetPayload",
    "kind": "LinkedField",
    "name": "updateTaskSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskSet",
        "kind": "LinkedField",
        "name": "taskSet",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instanceName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecast",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instanceCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhaseType",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumn",
            "kind": "LinkedField",
            "name": "statusColumn",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "instancesUpdated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTaskSetMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTaskSetMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "50874e1765650484025f1ae17771b8df",
    "id": null,
    "metadata": {},
    "name": "updateTaskSetMutation",
    "operationKind": "mutation",
    "text": "mutation updateTaskSetMutation(\n  $input: UpdateTaskSetInput!\n) {\n  updateTaskSet(input: $input) {\n    taskSet {\n      id\n      name\n      instanceName\n      description\n      estimateForecast\n      billable\n      instanceCount\n      role {\n        id\n      }\n      phase {\n        id\n      }\n      statusColumn {\n        id\n      }\n    }\n    instancesUpdated\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff83d52a2506218a526abe7294378a25";

export default node;
